import type { ButtonHTMLAttributes, FC, ReactNode } from 'react'

export type ButtonKind = 'primary' | 'ghost'

export interface ButtonProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'className' | 'children'> {
  kind?: ButtonKind
  icon?: ReactNode
  children?: ReactNode
}

export const Button: FC<ButtonProps> = ({
  kind = 'ghost',
  icon,
  children,
  type = 'button',
  disabled,
  ...rest
}) => (
  <button
    {...rest}
    type={type}
    disabled={disabled}
    className={`btn btn--${kind}`}
  >
    {icon ? <span className="btn__icon">{icon}</span> : null}
    {children}
  </button>
)
